import classNames from "classnames";
import React, { ReactNode } from "react";
import "./ScrollableView.scss";

interface IScrollableViewProps {
  withAppBar?: boolean;
  style?: React.CSSProperties;
  onScroll?: (e: React.UIEvent<HTMLDivElement, UIEvent>) => void;
  className?: string;
  children?: ReactNode;
}

const ScrollableView = ({
  withAppBar,
  children,
  className,
  onScroll,
  style = {},
}: IScrollableViewProps) => (
  <div
    className={classNames(
      "scrollable-view-container",
      { "with-appbar": withAppBar },
      className,
    )}
    style={style}
    onScroll={onScroll}
  >
    {children}
  </div>
);

export default ScrollableView;
